<script setup lang="ts">
import { getCmsImage } from '@/composables/useCms';
import { useBlogPaths } from '@/composables/useBlogPaths';

const { locale } = useI18n();
const { getArticlePath } = useBlogPaths();

const props = defineProps<{ article: any }>();

const formatDate = (date: string) => new Date(date).toLocaleDateString(locale.value, { day: 'numeric', month: 'long', year: 'numeric' });
</script>

<template>
  <NuxtLink :to="getArticlePath(article)" class="flex flex-col border rounded overflow-hidden hover:shadow-md transition-shadow">
    <NuxtImg v-if="article.image?.[0]?.url" :src="getCmsImage(article.image)" :alt="article.image[0].title" class="w-full object-cover h-48" />
    <div class="p-5 flex flex-col flex-1">
      <div class="mb-3">
        <span
          v-for="tag in article.tags"
          :key="tag.slug"
          class="inline-block bg-primary text-white text-xs font-semibold px-2 py-0.5 rounded-full mr-1 mb-1"
        >
          {{ tag.title }}
        </span>
      </div>
      <h3 class="text-lg font-semibold mb-2">{{ article.title }}</h3>
      <div class="text-gray-600 text-sm mb-4" v-html="article.shortDescription?.html"></div>
      <div class="flex items-center gap-2 text-gray-400 text-xs mt-auto pt-3">
        <span v-if="article.authorBlog?.[0]?.title">{{ article.authorBlog[0].title }}</span>
        <span>{{ formatDate(article.postDate) }}</span>
      </div>
    </div>
  </NuxtLink>
</template>
